@if (markerSet) {
	<div class="markerSetPane">
		@for (icon of markerSet?.icons; track TrackByMethods.trackByIndex(i, icon); let i = $index) {
			<div
				class="markerSetIconButton clickable"
				mat-ripple
				[class.defaultBookmarks]="i <= 2"
				[class.markerSetCustomIconButton]="icon.isCustomMarker"
				[class.inactive]="scenarioRecording?.state === ScenarioRecordingState.Prepared"
				(click)="addMarker.emit(icon)"
				[class.durationOn]="isDurationActive(icon)"
			>
				<!--ICON BOOKMARK-->
				@if (!icon.isTextMarker) {
					<img
						[src]="icon.url"
						class="mat-icon"
						[class.markerSetPaneIcon]="!icon.isCustomMarker"
						[class.markerSetPaneCustomIcon]="icon.isCustomMarker"
						[class.noFilterMarker]="disableFilterForIcon(icon.name)"
						[class.durationOn]="isDurationActive(icon)"
						[ngClass]="{largex2: i > 2, largex3: i <= 2}"
						[alt]="icon.name"
					/>
				} @else {
					<span
						class="textMarker"
						[class.noFilterMarker]="disableFilterForIcon(icon.name)"
						[class.durationOn]="isDurationActive(icon)"
						[matTooltip]="icon.tooltip"
					>
						{{ icon.abbreviation }}
					</span>
				}
				<!--TEXT MARKER-->
				@if (icon.isEnduring) {
					<mat-icon class="timerIcon" fontSet="fad" fontIcon="fa-stopwatch" inline />
				}
				@if (SimUtilityService.isInElectron() ? i + 1 <= 12 : i + 1 <= 3) {
					<div class="shortCutHint">F{{ i + 1 }}</div>
				}
			</div>
		}
	</div>
}
